import { apiSlice } from "../../app/api/apiSlice";

export const quickPricerPopulateFieldsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		quickPricerPopulateFields: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/quickpricer_custom_fields/",
				method: "POST",
				body: credentials,
			}),
		}),
	}),
});

export const { useQuickPricerPopulateFieldsMutation } = quickPricerPopulateFieldsApiSlice;

